import { render, staticRenderFns } from "./test-detail.vue?vue&type=template&id=07f762c0&scoped=true"
import script from "./test-detail.vue?vue&type=script&lang=js"
export * from "./test-detail.vue?vue&type=script&lang=js"
import style0 from "./test-detail.vue?vue&type=style&index=0&id=07f762c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f762c0",
  null
  
)

export default component.exports